import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=9c8dc5bc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c8dc5bc')) {
      api.createRecord('9c8dc5bc', component.options)
    } else {
      api.reload('9c8dc5bc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=9c8dc5bc&", function () {
      api.rerender('9c8dc5bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IJ4vR5LCpPvF/JS/offershelp.vue"
export default component.exports